<div *ngIf="options && options.length" class="form">
    <!-- list -->
    <div *ngFor="let option of options" [style.width]="option.widthDiv" [class.required-field]="isRequired(option)">
        <ng-container *ngIf="option.type == 'buttons' || (option.label === 'criticity' && option.type != 'buttons')">
            <ng-container *ngTemplateOutlet="toggleGroupForm; context: { config: option }">
            </ng-container>
        </ng-container>
        <ng-container *ngIf="option.type == 'select' && option.label !== 'criticity'">
            <ng-container *ngTemplateOutlet="selectForm; context: { config: option }">
            </ng-container>
        </ng-container>
        <ng-container *ngIf="option.type == 'dynamic'">
            <ng-container *ngTemplateOutlet="dynamicForm; context: { config: option }">
            </ng-container>
        </ng-container>
        <ng-container *ngIf="option.type == 'text'">
            <ng-container *ngTemplateOutlet="textForm; context: { config: option }">
            </ng-container>
        </ng-container>
        <ng-container *ngIf="option.type == 'textarea'">
            <ng-container *ngTemplateOutlet="textareaForm; context: { config: option }">
            </ng-container>
        </ng-container>
        <ng-container *ngIf="option.type == 'number'">
            <ng-container *ngTemplateOutlet="numberForm; context: { config: option }">
            </ng-container>
        </ng-container>
        <!-- <ng-container *ngIf="option.type == 'date'">
            <ng-container *ngTemplateOutlet="dateForm; context: { config: option }">
            </ng-container>
        </ng-container> -->
        <ng-container *ngIf="option.type == 'checkbox'">
            <ng-container *ngTemplateOutlet="checkboxForm; context: { config: option }">
            </ng-container>
        </ng-container>
        <!-- <ng-container *ngIf="option.type == 'radio'">
            <ng-container *ngTemplateOutlet="radioForm; context: { config: option }">
            </ng-container>

        </ng-container> -->
        <!-- <ng-container *ngIf="option.type == 'colors'">
            <ng-container *ngTemplateOutlet="colorsForm; context: { config: option }">
            </ng-container>
        </ng-container>
        <ng-container *ngIf="option.type == 'color'">
            <ng-container *ngTemplateOutlet="colorForm; context: { config: option }">
            </ng-container>
        </ng-container> -->


        <!-- <ng-container [ngTemplateOutlet]="textForm" [ngTemplateOutletContext]="{ config: option }"
            *ngIf="option.type == 'text'">
        </ng-container>
        <ng-container [ngTemplateOutlet]="textareaForm" [ngTemplateOutletContext]="{ config: option }"
            *ngIf="option.type == 'textarea'">
        </ng-container>
        <ng-container [ngTemplateOutlet]="numberForm" [ngTemplateOutletContext]="{ config: option }"
            *ngIf="option.type == 'number'">
        </ng-container>
        <ng-container [ngTemplateOutlet]="dateForm" [ngTemplateOutletContext]="{ config: option }"
            *ngIf="option.type == 'date'">
        </ng-container>
        <ng-container [ngTemplateOutlet]="checkboxForm" [ngTemplateOutletContext]="{ config: option }"
            *ngIf="option.type == 'checkbox'">
        </ng-container>
        <ng-container [ngTemplateOutlet]="radioForm" [ngTemplateOutletContext]="{ config: option }"
            *ngIf="option.type == 'radio'">
        </ng-container>
        <ng-container [ngTemplateOutlet]="colorsForm" [ngTemplateOutletContext]="{ config: option }"
            *ngIf="option.type == 'colors'">
        </ng-container>
        <ng-container [ngTemplateOutlet]="colorForm" [ngTemplateOutletContext]="{ config: option }"
            *ngIf="option.type == 'color'">
        </ng-container> -->
    </div>
    <!-- <button class="button-primary" mat-flat-button color="primary" (click)="save()">
        Enregistrer
    </button> -->

    <!-- criticity toggle group -->
    <ng-template #toggleGroupForm let-config="config">
        <div class="toggle-group-field">
            <span class="toggle-group-label">{{ displayLabel(config) }}</span>
            <mat-button-toggle-group
                [(ngModel)]="config.value"
                [disabled]="disabled"
                (change)="onToggleChange()"
                [hideSingleSelectionIndicator]="true"
                [ngModelOptions]="{ standalone: true }">
                <mat-button-toggle *ngFor="let opt of config.options" [value]="opt">
                    {{ opt }}
                </mat-button-toggle>
            </mat-button-toggle-group>
        </div>
    </ng-template>

    <!-- select -->
    <ng-template #selectForm let-config="config">
        <mat-form-field appearance="outline" [ngClass]="{'disabled': disabled}">
            <mat-label>{{ displayLabel(config) }}</mat-label>
            <ng-container *ngIf="!config.multiple">
                <mat-select [disabled]="disabled" readonly matInput [(ngModel)]="config.value" [class]="config.customClass" (blur)="onChange($event)"
                    [ngModelOptions]="{ standalone: true }" size="5" panelPosition="above">
                    <mat-option [value]="opt" *ngFor="let opt of config.options">{{ opt }}</mat-option>
                </mat-select>
            </ng-container>
            <ng-container *ngIf="config.multiple">
                <mat-select [disabled]="disabled" matInput [(ngModel)]="config.value" [ngModelOptions]="{ standalone: true }" (blur)="onChange($event)" panelPosition="above">
                    <mat-option [value]="opt" *ngFor="let opt of config.options">{{ opt }}</mat-option>
                </mat-select>
            </ng-container>
        </mat-form-field>
    </ng-template>

    <!-- checkbox -->
    <ng-template #checkboxForm let-config="config">
        <mat-form-field appearance="outline">
            <mat-label>{{ displayLabel(config) }}</mat-label>
            <ng-container *ngIf="!config.multiple">
                <mat-select matInput [(ngModel)]="config.value" [class]="config.customClass" (blur)="onChange($event)"
                    size="5" multiple>
                    <mat-option [value]="opt" *ngFor="let opt of config.options">{{ opt }}</mat-option>
                </mat-select>
            </ng-container>
            <ng-container *ngIf="config.multiple">
                <mat-select matInput [(ngModel)]="config.value" [ngModelOptions]="{ standalone: true }" (blur)="onChange($event)">
                    <mat-option [value]="opt" *ngFor="let opt of config.options">{{ opt }}</mat-option>
                </mat-select>
            </ng-container>
        </mat-form-field>
    </ng-template>

    <!-- dynamic -->
    <ng-template #dynamicForm let-config="config">
        <mat-form-field appearance="outline" [ngClass]="{'disabled': disabled}">
            <mat-label>{{ displayLabel(config) }}</mat-label>
            <mat-select [disabled]="disabled" matInput [(ngModel)]="config.value" [ngModelOptions]="{ standalone: true }" (blur)="onChange($event)" multiple
                (openedChange)="!$event && onDynamicPanelClose(config)">
                <div class="search-select">
                    <mat-icon class="search-icon">search</mat-icon>
                    <input class="search-input" matInput placeholder="Rechercher..."
                        [value]="dynamicSearchTexts[config.label] || ''"
                        (input)="onDynamicSearch(config, $event)"
                        (click)="$event.stopPropagation()"
                        (keydown)="$event.stopPropagation()" />
                    <mat-icon class="clear-search-icon"
                        *ngIf="dynamicSearchTexts[config.label]"
                        (click)="clearDynamicSearch(config); $event.stopPropagation()">close</mat-icon>
                </div>
                <mat-option [value]="opt" *ngFor="let opt of config.labelOption?.values"
                    [style.display]="matchesDynamicSearch(config, opt) ? '' : 'none'">{{ opt }}</mat-option>
            </mat-select>
        </mat-form-field>
    </ng-template>

    <!-- text -->
    <ng-template #textForm let-config="config">
        <mat-form-field appearance="outline" class="" [style.width]="config.width">
            <mat-label>{{ displayLabel(config) }}</mat-label>
            <input matInput type="text" placeholder="" [(ngModel)]="config.value" [style.height]="config.height"  (change)="onChange($event)"
                [ngModelOptions]="{ standalone: true }" />
        </mat-form-field>
    </ng-template>

    <!-- textarea -->
    <ng-template #textareaForm let-config="config">
        <mat-form-field appearance="outline" class="" [style.width]="config.width">
            <mat-label>{{ displayLabel(config) }}</mat-label>
            <textarea matInput placeholder="" [(ngModel)]="config.value" [style.height]="config.height"  (change)="onChange($event)"></textarea>
        </mat-form-field>
    </ng-template>

    <!-- number -->
    <ng-template #numberForm let-config="config">
        <mat-form-field appearance="outline" class="" [style.width]="config.width">
            <mat-label>{{ displayLabel(config) }}</mat-label>
            <input matInput type="number" placeholder="0" [(ngModel)]="config.value"  (change)="onChange($event)"
                [ngModelOptions]="{ standalone: true }" [min]="config.min !== undefined ? config.min : null"
                [max]="config.max !== undefined ? config.max : null" />
        </mat-form-field>
    </ng-template>

    <!-- date -->
    <!-- <ng-template #dateForm let-config="config">
        <mat-form-field [style.width]="config.width" appearance="outline">
            <mat-label>{{ displayLabel(config) }}</mat-label>
            <input type="datetime" date-time [(ngModel)]="config.value" [ngModelOptions]="{ standalone: true }"
                auto-close="true" view="date" appearance="outline" matInput [ngxMatDatetimePicker]="date"
                [disabled]="config.noEdit" />
            <mat-datepicker-toggle appearance="outline" matSuffix [for]="date"></mat-datepicker-toggle>
            <ngx-mat-datetime-picker #date>
                <ng-template>
                    <span>OK</span>
                </ng-template>
            </ngx-mat-datetime-picker>
        </mat-form-field>
    </ng-template> -->

    <!-- checkbox: standalone checkbox (do not delete, in case we need to bring it back) -->
    <!-- <ng-template #checkboxForm let-config="config">
        <mat-checkbox [(ngModel)]="config.value" [ngModelOptions]="{ standalone: true }"
            [style.width]="config.width || '250px'" [class]="config.customClass"  (change)="onChange($event)">
            {{ displayLabel(config) }}</mat-checkbox>
        <div class="group box-input" *ngIf="config.groupKey && config.value">
        </div>
    </ng-template> -->
</div>
